export default __webpack_public_path__ + "31d4c17d4760c6147e3e8d2bd8a06585.png";